var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-con",on:{"click":_vm.showMessage}},[_c('Tooltip',{attrs:{"content":_vm.value > 0 ? '有' + _vm.value + '条未读消息' : '无未读消息',"placement":"bottom"}},[_c('Badge',{attrs:{"count":_vm.value,"dot":""}},[_c('Icon',{attrs:{"type":"ios-bell","size":22}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ab6b75a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/main-components/message-tip.vue
// module id = null
// module chunks = 